<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>店铺名称：</label>
                <el-input v-model="search_Obj.f_shop_name" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>手机号码：</label>
                <el-input v-model="search_Obj.f_phone" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column type="selection" align="center" width="50"></el-table-column>
                <el-table-column prop="shop_name" label="店铺名称" sortable="custom"></el-table-column>
                <el-table-column prop="city" label="城市" sortable="custom"></el-table-column>
                <el-table-column prop="model" label="车型" sortable="custom"></el-table-column>
                <el-table-column prop="name" label="姓名" sortable="custom"></el-table-column>
                <el-table-column prop="phone" label="电话" sortable="custom"></el-table-column>
                <el-table-column prop="service" label="服务内容" sortable="custom"></el-table-column>
                <el-table-column prop="remark" label="备注" sortable="custom"></el-table-column>
                <el-table-column prop="add_time" label="添加时间" sortable="custom"></el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看店铺推送"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'shopSendList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '店铺推送',
            menu_id: 7900,
            list_url: "/api/admin/shopsend/list",
            search_Obj: {
                f_shop_name: '',
                f_phone: '',
            },
            del_Obj:{
                url:'/api/admin/shopsend/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>